import {
  InputRequirement,
  InputRequirementSchema,
  ToolResultOutputSchema,
} from "@intelligems/ig-types";

export const readRequestUserInputOutput = (
  output: unknown
): InputRequirement | undefined => {
  const parsedOutput = ToolResultOutputSchema.safeParse(output);
  if (!parsedOutput.success || parsedOutput.data.type !== "json") {
    return undefined;
  }

  const parsedRequirement = InputRequirementSchema.safeParse(
    parsedOutput.data.value.results
  );
  if (
    !parsedRequirement.success ||
    typeof parsedRequirement.data.prompt !== "string"
  ) {
    return undefined;
  }

  return parsedRequirement.data;
};
